import classNames from 'classnames'
import React from 'react'

type PropTypes = {
  className?: string
  children: React.ReactNode
  colSpan?: number
}

const Cell = ({ className, children, colSpan }: PropTypes) => {
  return (
    <td
      className={classNames('pt-[19px] pb-[17px] text-sm leading-[14px] truncate group-hover/callback:bg-gray-50', className)}
      colSpan={colSpan}
    >
      {children}
    </td>
  )
}

export default Cell
